import QRScannerButton from "../../Drawers/QRScannerDrawer/QRScannerButton";
import { ReusableViewIDs, View } from "../../../types/PageInterfaces";
import PageViewCalendar from "../PageViewCalendar/PageViewCalendar";
import PageViewTimeline from "./PageViewBoard/PageViewTimeline";
import SharedToolbar from "./SharedToolbar/SharedToolbar";
import PageViewCards from "./PageViewCards/PageViewCards";
import PageViewBoard from "./PageViewBoard/PageViewBoard";
import { SharedViewModes } from "../PageViewRenderer";
import PageViewTables from "./PageViewTables";

/**
 * Handles Table, Cards, and Board views
 * All Views can be in one of the above modes. The View Type decides what is displayed by default.
 */
function PageViewShared({
  view,
  viewMode,
  setViewMode,
  parentViewID,
  showInsights,
  record,
  reusableViews,
  commentsWidget,
}: {
  view: View;
  viewMode: SharedViewModes;
  setViewMode: (newMode: SharedViewModes) => void;
  parentViewID?: string;
  showInsights?: boolean;
  record?: any;
  commentsWidget?: boolean;
  reusableViews?: ReusableViewIDs;
}) {
  if (!view) return null;

  let Child = null;

  if (viewMode === "Table") {
    Child = PageViewTables;
  }
  if (viewMode === "Cards") {
    Child = PageViewCards;
  }
  if (viewMode === "Board") {
    Child = PageViewBoard;
  }
  if (viewMode === "Timeline") {
    Child = PageViewTimeline;
  }
  if (viewMode === "Calendar") {
    Child = PageViewCalendar;
  }

  return (
    <div>
      <SharedToolbar
        ChildComponent={Child ? Child : Empty}
        view={view}
        parentViewID={parentViewID}
        viewMode={viewMode}
        setViewMode={setViewMode}
        record={record}
        showInsights={showInsights}
        reusableViews={reusableViews}
        commentsWidget={commentsWidget}
      />
      <QRScannerButton view={view} parentRecord={record} />
    </div>
  );
}

function Empty() {
  return <>Invalid View Mode.</>;
}

export default PageViewShared;
